export default (str) => {
  return str.startsWith('http') && str.match(/(jpg|gif|png|jpeg|bmp)/)
}
